import { Store } from 'src/store/index';

const getCategoryId = (store: Store) => store.design.categoryId;

export default getCategoryId;
